export default "__VITE_ASSET__DQJmO8VA__"